import React, { useState } from 'react';
import jobActions from '../../../../../actions/jobs';

export default function FeedbackButtons({ jobId, jobType, onUseAsInput, imageUrl }) {
  const [feedback, setFeedback] = useState(null);

  const btnStyle = (active, color) => ({
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    width: 26, height: 26, borderRadius: '50%',
    background: active ? `${color}18` : 'transparent',
    border: active ? `1px solid ${color}40` : '1px solid transparent',
    color: active ? color : 'rgba(255,255,255,0.25)',
    cursor: 'pointer', fontSize: 13, padding: 0,
    transition: 'all 150ms ease',
  });

  const handleFeedback = async (type) => {
    if (!jobId || !jobType) return;
    const newVal = feedback === type ? null : type;
    setFeedback(newVal);
    if (type === 'like') {
      try { await jobActions.toggleLike(jobId, jobType); } catch { /* non-critical */ }
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <button
        title="Good result"
        aria-label="Like this result"
        style={btnStyle(feedback === 'like', '#4ade80')}
        onClick={() => handleFeedback('like')}
      >👍</button>
      <button
        title="Needs improvement"
        aria-label="Dislike this result"
        style={btnStyle(feedback === 'dislike', '#f87171')}
        onClick={() => handleFeedback('dislike')}
      >👎</button>
      {onUseAsInput && imageUrl && (
        <button
          title="Use as input for next generation"
          aria-label="Use image as input"
          style={{
            ...btnStyle(false, '#FF7E67'),
            width: 'auto', borderRadius: 6, padding: '0 8px', fontSize: 10,
            fontWeight: 500, letterSpacing: '0.02em',
          }}
          onClick={() => onUseAsInput(imageUrl)}
        >Use as input</button>
      )}
    </div>
  );
}
